const Specialties = () => {
  const specialties = [
    {
      title: "Montaditos Gourmet",
      description: "Piripi, Solomillo al whisky y más",
      image: "https://images.unsplash.com/photo-1541014741259-de529411b96a?w=600&h=700&fit=crop",
    },
    {
      title: "Ibéricos Premium",
      description: "Jamón de bellota y embutidos selectos",
      image: "https://images.unsplash.com/photo-1767500536251-e9781c0b5eb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjaGFyY3V0ZXJpZSUyMGJvYXJkJTIwY3VyZWQlMjBtZWF0JTIwcGxhdHRlcnxlbnwwfHx8fDE3NzMzNDc0NDd8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Carnes a la Brasa",
      description: "Solomillo ibérico y vacuno retinto",
      image: "https://images.unsplash.com/photo-1558030006-450675393462?w=600&h=700&fit=crop",
    },
    {
      title: "Mariscos Frescos",
      description: "De la costa andaluza a tu mesa",
      image: "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=600&h=700&fit=crop",
    },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            Nuestra cocina
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Ibéricos de Bellota y Carnes a la Brasa
          </h2>
          <p className="font-body text-[#1A1A1A]/70 max-w-2xl mx-auto">
            Nuestra carta está elaborada con ingredientes cuidadosamente seleccionados
            para ofrecer una experiencia gastronómica auténtica.
          </p>
        </div>

        {/* Specialties Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialties.map((specialty, index) => (
            <div
              key={index}
              className="specialty-card group cursor-pointer h-[400px] img-zoom"
              data-testid={`specialty-card-${index}`}
            >
              <img
                src={specialty.image}
                alt={specialty.title}
                className="w-full h-full object-cover"
              />
              <div className="specialty-card-content">
                <h3 className="font-heading text-xl mb-2">{specialty.title}</h3>
                <p className="font-body text-sm text-white/80">
                  {specialty.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#carta"
            onClick={(e) => scrollToSection(e, "#carta")}
            data-testid="specialties-cta"
            className="btn-secondary inline-block"
          >
            Ver Carta Completa
          </a>
        </div>
      </div>
    </section>
  );
};

export default Specialties;
